import { Link } from 'react-router-dom';
import { Button } from '@pnl/ui';

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center gap-6 py-20 text-center">
      <p className="text-ink-300 font-mono text-7xl font-bold">404</p>
      <div>
        <h1 className="font-display text-ink-900 text-2xl font-semibold">Página não encontrada</h1>
        <p className="text-ink-500 mt-1 text-sm">O recurso solicitado não existe ou foi movido.</p>
      </div>
      <Link to="/">
        <Button>Voltar para o dashboard</Button>
      </Link>
    </div>
  );
}
